var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select-field',{attrs:{"standart":true,"validation":_vm.$v,"validationMessage":_vm.textRequired,"list":_vm.$root.sortedCountryList,"label":_vm.textLabel,"rest":{
    placeholder: _vm.placeholder
      ? _vm.textPlaceholder
      : null,
    autocomplete: 'country-name',
    name: 'country-name',
  },"theme":"variant-1","tabindex":_vm.tabindex,"order":_vm.order},on:{"input":_vm.onChange},model:{value:(_vm.form[_vm.name]),callback:function ($$v) {_vm.$set(_vm.form, _vm.name, $$v)},expression:"form[name]"}})}
var staticRenderFns = []

export { render, staticRenderFns }